/**
 * Dynamic Branding Utility
 * Manages dynamic title and favicon based on domain
 */

// Domain-specific configurations (keep in sync with index.html)
const DOMAIN_CONFIGS = {
  'wallet.moneyplantfxfze.com': {
    title: 'MoneyPlantFX FZE - Secure Financial Platform',
    favicon: '/favicons/moneyplant-favicon.ico'
  },
  'wallet.nexorfx.com': {
    title: 'Nexora - Secure Financial Platform',
    favicon: '/nexorawhite.ico'
  },
  'wallet.fxcapital24.com': {
    title: 'FXCapital24 - Advanced Trading Platform',
    favicon: '/favicons/fxcapital-favicon.ico'
  },
  'localhost': {
    title: 'Nexora - Secure Financial Platform',
    favicon: '/nexorawhite.ico'
  },
  // Default fallback
  'default': {
    title: process.env.REACT_APP_SITE_TITLE || 'Moneyplant',
    favicon: process.env.REACT_APP_FAVICON_URL || '/favicon.ico'
  }
};

/**
 * Get domain-specific configuration
 * @returns {Object} Configuration object with title and favicon
 */
export const getDomainConfig = () => {
  const hostname = window.location.hostname;
  return DOMAIN_CONFIGS[hostname] || DOMAIN_CONFIGS['default'];
};

/**
 * Update page title
 * @param {string} title - New page title
 */
export const updatePageTitle = (title) => {
  if (document.title !== title) {
    document.title = title;
  }
};

/**
 * Update favicon
 * @param {string} faviconUrl - URL to the new favicon
 */
export const updateFavicon = (faviconUrl) => {
  // Update existing favicon or create new one
  const existingFavicon = document.querySelector('link[rel="icon"]');
  if (existingFavicon) {
    existingFavicon.href = faviconUrl;
  } else {
    const link = document.createElement('link');
    link.rel = 'icon';
    link.href = faviconUrl;
    document.head.appendChild(link);
  }
};

/**
 * Apply domain-specific branding (title and favicon)
 * This should be called as early as possible to prevent flickering
 */
export const applyDomainBranding = () => {
  const config = getDomainConfig();
  
  // Update title
  updatePageTitle(config.title);
  
  // Update favicon
  updateFavicon(config.favicon);
};

/**
 * Initialize domain branding with whitelabel data
 * @param {Object} whitelabelData - Whitelabel configuration from API
 */
export const initializeWhitelabelBranding = (whitelabelData) => {
  if (whitelabelData && Object.keys(whitelabelData).length > 0) {
    // Use whitelabel data if available
    if (whitelabelData.siteTitle) {
      updatePageTitle(whitelabelData.siteTitle);
    } else if (whitelabelData.companyName) {
      // Fallback to company name if siteTitle is not available
      updatePageTitle(`${whitelabelData.companyName} - Financial Platform`);
    }
    
    // For favicon, we'll use domain-based configuration as whitelabel
    // data doesn't seem to include favicon information in the current implementation
    const config = getDomainConfig();
    updateFavicon(config.favicon);
  } else {
    // Fallback to domain-based configuration
    applyDomainBranding();
  }
};